import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';

import Authenticated from '@brokerage/Authenticated';
import AdminLogin from '@brokerage/pages/AdminLogin';
import AdminsList from '@brokerage/pages/admins/List';
import AgenciesList from '@brokerage/pages/agencies/List';
import AgencyShow from '@brokerage/pages/agencies/Show';
import CarriersList from '@brokerage/pages/carriers/List';
import CarriersShow from '@brokerage/pages/carriers/Show';
import ConfigFieldsShow from '@brokerage/pages/config_fields/ConfigFieldsShow';
import NewCarrier from '@brokerage/pages/carriers/NewCarrier';
import MobileAppsList from '@brokerage/pages/mobile_apps/MobileAppsList';
import MembersList from '@brokerage/pages/members/List';
import MemberShow from '@brokerage/pages/members/Show';
import MobileAppsShow from '@brokerage/pages/mobile_apps/MobileAppsShow';
import ApiTokens from '@brokerage/pages/ApiTokens';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

import '@css/base/reset.css';
import { Provider } from 'react-redux';
import store from '@redux/store';
import { createRoot } from 'react-dom/client';

const config = require('../config');
const container = document.getElementById('root');
const root = createRoot(container);

posthog.init(config.PostHogKey, {
  api_host: 'https://us.i.posthog.com'
});

root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <Provider store={store}>
        <HashRouter>
          <Routes>
            <Route element={<AdminLogin />} index={true} />
            <Route element={<Authenticated />}>
              <Route element={<AdminsList />} path='admins' />
              <Route element={<AgenciesList />} path='agencies' />
              <Route element={<AgencyShow />} path='agencies/:agency_id/*' />
              <Route element={<CarriersList />} path='carriers/*' />
              <Route element={<CarriersShow />} path='carriers/:carrier_id/*' />
              <Route element={<NewCarrier />} path='carriers/new' />
              <Route element={<ConfigFieldsShow />} path='config_fields/*' />
              <Route element={<MembersList />} path='members' />
              <Route element={<MemberShow />} path='members/:id/*' />
              <Route element={<MobileAppsList />} path='mobile_apps' />
              <Route element={<MobileAppsShow />} path='mobile_apps/:guid/*' />
              <Route element={<ApiTokens />} path='api_tokens' />
            </Route>
          </Routes>
        </HashRouter>
      </Provider>
    </PostHogProvider>
  </React.StrictMode>
);
